// VI overrides cho integrations/data.js (data gốc giữ ở English).
// Khi `lang === 'vi'`, `localizePlatform()` merge các trường có override; nếu
// thiếu thì fallback về English. `products` và `scopes` là tên kỹ thuật/scope
// chuẩn, không dịch.

const VI_PLATFORMS = {
  tiktok: {
    description:
      'Creator cấp quyền qua TikTok Login Kit. Backend của chúng tôi trao đổi OAuth code (client secret ở server-side) và lưu profile. Người dùng có thể duyệt video của mình qua Display API và đăng video mới qua Content Posting API.',
    compliance: [
      'Tuân thủ creator_info ở mọi lần publish (mức privacy được phép, max_video_post_duration_sec, khoá tương tác ở cấp tài khoản)',
      'UI disclosure Branded Content hiển thị yêu cầu nhãn Promotional content / Paid partnership',
      'Access token được mã hoá AES-256-GCM khi lưu',
    ],
    screenshots: {
      '01': {
        title: 'Kết nối qua TikTok OAuth',
        desc:
          'Người dùng cấp quyền qua màn hình consent chính thức của TikTok bằng Login Kit (user.info.basic, user.info.profile). Client secret luôn ở phía server.',
      },
      '02': {
        title: 'Khu vực tài khoản đã kết nối',
        desc:
          'Toàn bộ tài khoản TikTok đã kết nối trong một dashboard, có toggle trạng thái, link nhanh tới profile TikTok công khai và thao tác theo từng tài khoản.',
      },
      '03': {
        title: 'Chi tiết tài khoản & đồng bộ profile',
        desc:
          'Dữ liệu profile lấy từ TikTok — tên hiển thị, username, avatar, bio — kèm nút re-sync và bộ đếm bài đăng 24h.',
      },
      '04': {
        title: 'Duyệt video qua Display API',
        desc:
          'Thư viện video chỉ đọc dùng scope video.list — cover image, tiêu đề, lượt xem/like/comment/share, phân trang cursor.',
      },
      '05': {
        title: 'Soạn bài với creator_info gating',
        desc:
          'Trình soạn bài tuân theo creator_info: mức privacy được phép, độ dài video tối đa, khoá comment/duet/stitch theo tài khoản, và disclosure Branded Content.',
      },
      '06': {
        title: 'Đăng bài qua Content Posting API',
        desc:
          'video.upload + video.publish — bài đăng lên TikTok và share_url trả về được lưu để đối soát.',
      },
    },
    useCases: {
      'Marketing agencies': {
        title: 'Agency marketing',
        desc:
          'Quản lý đăng video TikTok cho nhiều brand client từ một workspace duy nhất. Mỗi tài khoản TikTok đã kết nối thuộc về client đã cấp quyền cho agency qua TikTok OAuth.',
      },
      'In-house content teams': {
        title: 'Đội ngũ content nội bộ',
        desc:
          'Đội marketing SMB lên kế hoạch, lên lịch và review video TikTok một cách hợp tác, song song với nội dung Facebook, Instagram và YouTube từ cùng một dashboard.',
      },
      'Solo creators': {
        title: 'Creator cá nhân',
        desc:
          'Creator độc lập lên lịch video TikTok cùng với 7 nền tảng social khác từ một nơi — không cần chuyển qua lại giữa các app native để đăng bài.',
      },
      'Timezone-aware scheduling': {
        title: 'Lên lịch theo múi giờ',
        desc:
          'Lên lịch đăng TikTok vào khung giờ vàng với hỗ trợ timezone Asia/Ho_Chi_Minh, auto-retry khi lỗi tạm thời, và bộ đếm bài đăng 24h để tôn trọng rate limit của TikTok.',
      },
    },
    scopeJustifications: {
      'user.info.basic': {
        feature: 'OAuth callback & định danh tài khoản',
        reason:
          'Cần thiết để lấy open_id khi user cấp quyền cho app. open_id là cách chúng tôi định danh và tra cứu tài khoản TikTok đã kết nối trong database.',
      },
      'user.info.profile': {
        feature: 'Hiển thị danh tính creator trong UI',
        reason:
          'Dùng để hiển thị display_name, avatar_url, username và bio_description ở danh sách tài khoản, trang chi tiết và trình soạn bài — để user biết đang đăng lên tài khoản TikTok nào.',
      },
      'video.list': {
        feature: 'Thư viện video chỉ đọc trên trang chi tiết tài khoản',
        reason:
          'Cho phép user đã kết nối duyệt video TikTok của mình (cover, tiêu đề, lượt xem / like / comment / share) với phân trang cursor, và đối soát rằng bài đăng qua app đã lên TikTok.',
      },
      'video.upload': {
        feature: 'Upload video của user lên Content Posting API',
        reason:
          'Bước đầu tiên của publish — upload file MP4 của user lên endpoint ingestion của TikTok. Không có scope này, không có video nào gửi lên TikTok được.',
      },
      'video.publish': {
        feature: 'Hoàn tất upload thành bài TikTok live',
        reason:
          'Publish video đã upload kèm caption, privacy_level, disable_comment / disable_duet / disable_stitch, và disclosure Branded Content — để bài lên profile TikTok của creator.',
      },
    },
    testingSteps: {
      1: {
        title: 'Đăng nhập dashboard',
        desc:
          'Truy cập https://social-panel.adda.link/auth/sign-in và đăng nhập với tài khoản test reviewer được cấp trong note submission App Review.',
      },
      2: {
        title: 'Mở module TikTok',
        desc:
          "Click 'Tài khoản TikTok' ở sidebar trái (route /admin/tiktok). Bạn sẽ thấy danh sách tài khoản TikTok đã kết nối.",
      },
      3: {
        title: 'Kết nối tài khoản TikTok',
        desc:
          "Click 'Kết nối TikTok' → ở trang tiếp click 'Đăng nhập TikTok' → cấp quyền qua màn hình consent chính thức của TikTok → đặt tên hiển thị → click 'Hoàn tất kết nối'.",
      },
      4: {
        title: 'Duyệt video TikTok (Display API)',
        desc:
          "Từ danh sách tài khoản click icon mắt → ở trang chi tiết click 'Xem video trên TikTok' để load video của user qua scope video.list.",
      },
      5: {
        title: 'Soạn và đăng video',
        desc:
          "Navigate sang 'Bài viết TikTok' → 'Tạo bài viết' → chọn tài khoản đã kết nối → upload MP4 (hoặc 1-35 ảnh) → đặt caption, privacy, toggle → chọn 'Đăng ngay' → submit.",
      },
      6: {
        title: 'Đối soát trên TikTok',
        desc:
          "Đợi toast success. Bài mới hiện ở danh sách với badge xanh 'Đã đăng' và permalink. Click permalink để mở video đã đăng trên tiktok.com.",
      },
    },
    faq: {
      0: {
        q: 'Tại sao app cần video.publish?',
        a:
          'Tính năng cốt lõi của Social Panel là publish có lịch trên nhiều platform. video.publish cho phép chúng tôi hoàn tất video đã upload thành bài TikTok live, thay mặt creator đã cấp quyền cho app vì mục đích này. Không có scope đó, app không thể delivery giá trị publish cho user.',
      },
      1: {
        q: 'creator_info được tuân thủ thế nào?',
        a:
          'Trước khi hiện trình soạn bài, backend gọi /v2/post/publish/creator_info/query/. UI sau đó disable các privacy option không có trong privacy_level_options, khoá toggle comment / duet / stitch nếu account đã disable global, và reject video dài hơn max_video_post_duration_sec ở bước upload.',
      },
      2: {
        q: 'TikTok client_secret được lưu ở đâu?',
        a:
          'Chỉ ở server-side, trong env của backend. Browser chỉ nhận client_key public. Việc trao đổi OAuth code-to-token diễn ra ở backend qua POST /api/v1/tiktok-account/oauth-callback.',
      },
      3: {
        q: 'Chuyện gì xảy ra nếu user revoke app trên TikTok?',
        a:
          "Các API call tiếp theo trả về lỗi authorization, backend capture và hiển thị badge 'Token expired' ở trang chi tiết tài khoản. User được nhắc reconnect tài khoản TikTok qua OAuth để refresh token — không mất dữ liệu trong hệ thống.",
      },
      4: {
        q: 'Disclosure Branded Content được xử lý thế nào?',
        a:
          'Trình soạn bài có 2 toggle — Branded Content (paid partnership) và Your Brand (sản phẩm riêng). Bật một trong hai sẽ hiện notice trong UI có link tới Branded Content Policy và TikTok Commercial Music Library, nhắc user rằng bài quảng cáo phải dùng nhạc thương mại. Cờ này được gửi lên TikTok khi publish để bài hiển thị đúng label trong feed.',
      },
      5: {
        q: 'access_token được lưu trữ an toàn thế nào?',
        a:
          'Token được mã hoá AES-256-GCM khi lưu vào database. Encryption key giữ ngoài database và rotate theo lịch định kỳ. Token không bao giờ được log, không bao giờ gửi tới browser, và không bao giờ chia sẻ giữa các workspace.',
      },
    },
  },
  facebook: {
    description:
      'Kết nối Facebook Page qua Facebook Login. Lên lịch và đăng bài text, hình, link, video qua Facebook Graph API. Scheduler chạy bằng cron xử lý đăng bài delayed theo timezone của workspace.',
    compliance: [
      'Access token OAuth được mã hoá AES-256-GCM khi lưu',
      'App secret luôn ở server-side; không có client_secret trong trình duyệt',
    ],
  },
  instagram: {
    description:
      'Kết nối tài khoản Instagram Business hoặc Creator qua Instagram API with Instagram Login (không cần Facebook Page). Xem hồ sơ đã kết nối và bài đã đăng, rồi đăng ảnh đơn, carousel và Reels — ngay hoặc theo lịch — qua Instagram Content Publishing API.',
    compliance: [
      'Token mã hoá AES-256-GCM khi lưu; app secret luôn ở server-side',
      'Media đăng qua luồng container-based publish (/media → /media_publish)',
      'Nút Ngắt kết nối thu hồi token đã lưu; có callback deauthorize & data-deletion',
    ],
    useCases: {
      'Marketing agencies': {
        title: 'Agency marketing',
        desc: 'Quản lý đăng bài Instagram cho nhiều brand client từ một workspace duy nhất. Mỗi tài khoản Instagram Business/Creator đã kết nối thuộc về client đã cấp quyền cho agency qua Instagram OAuth.',
      },
      'In-house content teams': {
        title: 'Đội ngũ content nội bộ',
        desc: 'Đội marketing SMB lên kế hoạch, lên lịch và review bài feed, carousel và Reels Instagram một cách hợp tác, song song với nội dung mạng xã hội khác từ cùng một dashboard.',
      },
      'Solo creators': {
        title: 'Creator cá nhân',
        desc: 'Creator độc lập lên lịch bài Instagram cùng với các nền tảng social khác từ một nơi — không cần chuyển qua lại giữa các app native để đăng bài.',
      },
      'Timezone-aware scheduling': {
        title: 'Lên lịch theo múi giờ',
        desc: 'Lên lịch đăng Instagram vào khung giờ vàng với hỗ trợ timezone Asia/Ho_Chi_Minh và auto-retry khi lỗi tạm thời.',
      },
    },
    scopeJustifications: {
      instagram_business_basic: {
        feature: 'Định danh tài khoản, hiển thị hồ sơ & lịch sử bài đã đăng',
        reason:
          'Cần để đọc hồ sơ Instagram Business/Creator đã kết nối (user ID, username, tên, avatar, loại tài khoản, số follower và số bài) và danh sách bài user đã đăng (caption, loại media, permalink, thời gian). Chúng tôi hiển thị ở danh sách tài khoản và trang chi tiết để user biết đang quản lý tài khoản nào và đối soát bài đăng qua app.',
      },
      instagram_business_content_publish: {
        feature: 'Đăng ảnh, carousel và Reels lên tài khoản của user',
        reason:
          'Cho phép user đăng nội dung họ soạn trong dashboard. Backend tạo media container (POST /{ig-user-id}/media) rồi publish (POST /{ig-user-id}/media_publish). Không có scope này, app không thể cung cấp tính năng đăng bài cốt lõi.',
      },
    },
    testingSteps: {
      1: {
        title: 'Đăng nhập dashboard',
        desc: 'Truy cập https://social-panel.adda.link/auth/sign-in và đăng nhập với tài khoản test reviewer được cấp trong note submission App Review.',
      },
      2: {
        title: 'Mở module Instagram',
        desc: "Click 'Instagram accounts' ở sidebar trái (route /admin/instagram). Bạn sẽ thấy danh sách tài khoản đã kết nối.",
      },
      3: {
        title: 'Kết nối tài khoản Instagram',
        desc: "Click 'Add' → ở trang tiếp click 'Sign in with Instagram' → cấp quyền trên màn hình consent chính thức của Instagram, gồm instagram_business_basic và instagram_business_content_publish → click 'Create'.",
      },
      4: {
        title: 'Xem hồ sơ & bài đã đăng (instagram_business_basic)',
        desc: "Từ danh sách tài khoản click icon mắt → trang chi tiết đọc hồ sơ qua GET /me và bài đã đăng qua GET /me/media. Click 'Sync from Instagram' để làm mới.",
      },
      5: {
        title: 'Soạn và đăng bài (instagram_business_content_publish)',
        desc: "Navigate sang 'Instagram posts' → 'Create post' → chọn tài khoản → chọn Single image, Carousel hoặc Reels → upload media → viết caption → chọn 'Publish now' → submit.",
      },
      6: {
        title: 'Đối soát trên Instagram',
        desc: "Đợi toast success. Bài mới hiện ở danh sách với badge 'Published' và permalink. Click để mở bài live trên instagram.com.",
      },
    },
    faq: {
      0: {
        q: 'Tại sao app cần instagram_business_content_publish?',
        a: 'Tính năng cốt lõi của Social Panel là publish có lịch trên nhiều platform. Scope này cho phép chúng tôi đăng ảnh, carousel và Reels mà user explicit soạn trong dashboard, thay mặt tài khoản Business/Creator họ đã cấp quyền. Không có nó, app không thể delivery giá trị publish.',
      },
      1: {
        q: 'Có cần Facebook Page hay Facebook Login không?',
        a: 'Không. Chúng tôi dùng Instagram API with Instagram Login (Business Login for Instagram), user cấp quyền trực tiếp bằng tài khoản Instagram Business/Creator — không cần liên kết Facebook Page và không cần Facebook Login.',
      },
      2: {
        q: 'Instagram app secret được lưu ở đâu?',
        a: 'Chỉ ở server-side, trong env của backend. Browser chỉ nhận Instagram app ID public. Việc trao đổi OAuth code-to-token diễn ra ở backend qua api.instagram.com/oauth/access_token.',
      },
      3: {
        q: 'Chuyện gì xảy ra nếu user revoke app trên Instagram?',
        a: 'Meta gọi callback deauthorize của chúng tôi; chúng tôi vô hiệu hóa tích hợp và xóa access token đã lưu ngay lập tức. Khi có yêu cầu data-deletion, chúng tôi purge tài khoản, token và metadata bài viết được cache. User cũng có thể ngắt kết nối bất cứ lúc nào trong dashboard.',
      },
    },
  },
  threads: {
    description:
      'Kết nối tài khoản Threads qua luồng Meta OAuth consent trên threads.net. Backend của chúng tôi đổi authorization code lấy long-lived token (client secret luôn ở server-side), sau đó user có thể xem profile và bài đã đăng (threads_basic) và soạn, lên lịch hoặc đăng ngay bài text/media (threads_content_publish).',
    compliance: [
      'Limited Use: dữ liệu Threads chỉ dùng để cung cấp các tính năng hiển thị ở đây. Chúng tôi không bán hoặc chuyển nhượng, không dùng cho hồ sơ quảng cáo, và không dùng để huấn luyện mô hình AI / ML',
      'Long-lived access token được mã hoá AES-256-GCM khi lưu; app secret luôn ở server-side và không bao giờ gửi tới trình duyệt',
      'Nút "Ngắt kết nối" một chạm xoá vĩnh viễn tài khoản, token và bài viết cache; chúng tôi cũng tuân thủ callback Deauthorize và Data Deletion của Meta và purge dữ liệu tối đa trong 30 ngày',
      'Chúng tôi chỉ đăng nội dung user explicit soạn trong dashboard — không bao giờ tự sinh hoặc tự đăng thay user',
      'Social Panel là công cụ độc lập của bên thứ ba, không liên kết, không được chứng thực hay tài trợ bởi Meta Platforms, Inc.',
    ],
    useCases: {
      'Marketing agencies': {
        title: 'Agency marketing',
        desc:
          'Đăng bài Threads cho nhiều brand client từ một workspace. Mỗi tài khoản Threads đã kết nối thuộc về client đã cấp quyền cho app qua màn hình consent của Meta.',
      },
      'In-house content teams': {
        title: 'Đội ngũ content nội bộ',
        desc:
          'Lên kế hoạch, lên lịch và review bài Threads một cách hợp tác, song song với nội dung Facebook, Instagram, YouTube và các nền tảng khác từ cùng một dashboard.',
      },
      'Solo creators': {
        title: 'Creator cá nhân',
        desc:
          'Creator độc lập soạn và lên lịch bài Threads cùng với 7 nền tảng social khác — không cần chuyển qua lại giữa các app native để đăng bài.',
      },
      'Timezone-aware scheduling': {
        title: 'Lên lịch theo múi giờ',
        desc:
          'Lên lịch đăng Threads vào khung giờ vàng với hỗ trợ timezone Asia/Ho_Chi_Minh, auto-retry khi lỗi tạm thời, và pipeline trạng thái rõ ràng nháp / đã lên lịch / đã đăng / lỗi.',
      },
    },
    scopeJustifications: {
      threads_basic: {
        feature: 'OAuth callback, hiển thị profile & danh sách bài đã đăng',
        reason:
          'Cần thiết để định danh tài khoản đã kết nối (user_id, username) sau khi cấp quyền và để hiển thị profile của user (tên, avatar, tiểu sử, số follower) qua GET /me và danh sách bài họ đã đăng qua GET /me/threads — để user xác nhận đúng tài khoản đã liên kết và review bài hiện có trước khi soạn bài mới.',
      },
      threads_content_publish: {
        feature: 'Đăng bài đã soạn lên tài khoản Threads của user',
        reason:
          'Tính năng cốt lõi của Social Panel là publish có lịch trên nhiều platform. Scope này cho phép backend tạo media container (POST /me/threads) và publish (POST /me/threads_publish) cho nội dung user đã explicit soạn trong dashboard. Không có scope đó, app không thể delivery giá trị publish cho user.',
      },
    },
    testingSteps: {
      1: {
        title: 'Đăng nhập dashboard',
        desc:
          'Truy cập https://social-panel.adda.link/auth/sign-in và đăng nhập với tài khoản test reviewer được cấp trong note submission App Review. UI mặc định tiếng Anh.',
      },
      2: {
        title: 'Mở module Threads',
        desc:
          "Click 'Threads accounts' ở sidebar trái (route /admin/threads). Bạn sẽ thấy danh sách tài khoản Threads đã kết nối.",
      },
      3: {
        title: 'Kết nối tài khoản Threads',
        desc:
          "Click 'Add' → ở trang tiếp click 'Sign in with Threads' → hoàn tất màn hình consent của Meta trên threads.net (có liệt kê cả threads_basic và threads_content_publish) → click 'Done' để lưu.",
      },
      4: {
        title: 'Xem profile & bài đã đăng (threads_basic)',
        desc:
          "Từ danh sách tài khoản click icon mắt để mở trang chi tiết → click 'Sync from Threads' để lấy profile và bài mới nhất qua GET /me và GET /me/threads → click 'View all posts' để duyệt.",
      },
      5: {
        title: 'Soạn và đăng bài (threads_content_publish)',
        desc:
          "Navigate sang 'Threads posts' (/admin/threads-post) → 'Create post' → chọn tài khoản đã kết nối → gõ tối đa 500 ký tự và đính kèm ảnh/video tuỳ chọn → chọn 'Publish now' → submit.",
      },
      6: {
        title: 'Đối soát trên Threads',
        desc:
          "Đợi toast success. Bài mới hiện ở danh sách với badge xanh 'Published' và permalink. Click permalink để mở bài đã đăng trên threads.net. Bạn cũng có thể click 'Disconnect' để thu hồi quyền và xoá dữ liệu vĩnh viễn.",
      },
    },
    faq: {
      0: {
        q: 'Tại sao app cần threads_content_publish?',
        a:
          'Tính năng cốt lõi của Social Panel là publish có lịch trên nhiều platform. threads_content_publish cho phép chúng tôi đăng một bài (text, ảnh, video hoặc carousel) mà user đã explicit soạn trong dashboard lên tài khoản Threads họ đã cấp quyền. Không có scope đó, app không thể delivery giá trị publish cho user.',
      },
      1: {
        q: 'Threads app secret / client_secret được lưu ở đâu?',
        a:
          'Chỉ ở server-side, trong env của backend. Browser chỉ mang OAuth authorization code. Việc trao đổi code-to-token (bao gồm th_exchange_token cho long-lived token) diễn ra ở backend qua POST /api/v1/threads-account/oauth-callback. Đây không phải app server-to-server — luồng đăng nhập Meta hiển thị đầy đủ với user.',
      },
      2: {
        q: 'Chuyện gì xảy ra khi user ngắt kết nối hoặc thu hồi app trên Threads?',
        a:
          "Nút 'Disconnect' xoá ngay và vĩnh viễn tài khoản đã kết nối, token và bài cache khỏi database. Nếu user gỡ app từ phía Threads, Meta gọi callback Deauthorize và chúng tôi xoá token đã lưu và vô hiệu hoá tích hợp.",
      },
      3: {
        q: 'User xoá dữ liệu của mình bằng cách nào?',
        a:
          'User có thể ngắt kết nối bất kỳ tài khoản nào chỉ một chạm, hoặc gửi yêu cầu xoá dữ liệu. Khi Meta gọi callback Data Deletion (hoặc user xoá tài khoản Social Panel), chúng tôi purge vĩnh viễn toàn bộ access token, user ID và metadata profile/bài Threads cache — tối đa 30 ngày trong mọi trường hợp, trừ khi pháp luật yêu cầu lưu giữ.',
      },
      4: {
        q: 'access_token được lưu trữ an toàn thế nào?',
        a:
          'Long-lived token được mã hoá AES-256-GCM trước khi ghi vào database. Encryption key giữ ngoài database. Token không bao giờ được log, không bao giờ gửi tới browser, và không bao giờ chia sẻ giữa các workspace.',
      },
    },
  },
  youtube: {
    description:
      'Kết nối kênh YouTube qua Google OAuth. Upload video, đặt title, description, tag, privacy và lên lịch qua YouTube Data API v3.',
    compliance: ['Token được mã hoá AES-256-GCM khi lưu', 'Resumable upload cho file lớn'],
  },
  'x-twitter': {
    description:
      'Kết nối tài khoản X qua OAuth 2.0 với PKCE. Soạn và lên lịch tweet, đính kèm media, và chain reply thành thread qua X API v2.',
    compliance: [
      'Luồng PKCE — không cần client_secret trong trình duyệt',
      'Refresh token được mã hoá AES-256-GCM khi lưu',
    ],
  },
  pinterest: {
    description:
      'Kết nối tài khoản Pinterest qua OAuth. Tạo Pin trên board được chọn, đặt destination link và mô tả, lên lịch publish pin qua Pinterest API v5.',
    compliance: ['Token được mã hoá AES-256-GCM khi lưu'],
  },
  telegraph: {
    description:
      'Đăng bài viết HTML / markdown dài lên Telegraph tức thời. Mỗi workspace có access token Telegraph riêng để quản lý bài viết của mình.',
    compliance: ['Access token theo từng tài khoản được mã hoá AES-256-GCM khi lưu'],
  },
};

export function localizePlatform(platform, lang) {
  if (lang !== 'vi') return platform;
  const v = VI_PLATFORMS[platform.slug];
  if (!v) return platform;
  return {
    ...platform,
    description: v.description || platform.description,
    compliance: v.compliance || platform.compliance,
    screenshots: (platform.screenshots || []).map(s => {
      const o = v.screenshots?.[s.step];
      return o ? { ...s, title: o.title, desc: o.desc } : s;
    }),
    useCases: (platform.useCases || []).map(u => {
      const o = v.useCases?.[u.title];
      return o ? { ...u, title: o.title, desc: o.desc } : u;
    }),
    scopeJustifications: (platform.scopeJustifications || []).map(j => {
      const o = v.scopeJustifications?.[j.scope];
      return o ? { ...j, feature: o.feature, reason: o.reason } : j;
    }),
    testingSteps: (platform.testingSteps || []).map(s => {
      const o = v.testingSteps?.[s.step];
      return o ? { ...s, title: o.title, desc: o.desc } : s;
    }),
    faq: (platform.faq || []).map((f, idx) => {
      const o = v.faq?.[idx];
      return o ? { ...f, q: o.q, a: o.a } : f;
    }),
  };
}
